var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-breadcrumb',{attrs:{"menu":[{label: _vm.customerId ? '编辑核心企业' : '新增核心企业'}]}}),_vm._v(" "),_c('company-edit-component',{attrs:{"data":_vm.debtorForm},on:{"update:data":function($event){_vm.debtorForm=$event},"onSubmit":_vm.onSubmit}}),_vm._v(" "),_c('button-back')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d479b56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/lender/CustomerAdmin/DebtorEdit.vue
// module id = null
// module chunks = 